export default __webpack_public_path__ + "static/media/logo.c91dbd3b.svg";